import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    ISieveConf,
    ISieveFilterObject,
    SieveOperator,
    SieveString
} from '../../helpers/sieve/sieveString.class';

@Component({
    selector: 'app-searchbox',
    templateUrl: 'searchbox.component.html',
    styleUrls: ['searchbox.component.css']
})
export class SearchboxComponent {
    @Output() changePageEvent = new EventEmitter<ISieveConf>();
    @Output() searchEvent = new EventEmitter<ISieveConf>();
    @Output() closeSearchBox = new EventEmitter<boolean>();
    @Output() searchBox = new EventEmitter<string>();

    @Input() page: number;
    @Input() pageSize: number;
    @Input() customFilterName: string;
    @Input() rowsTotal: number;
    @Input() label: string;
    @Input() property: string;
    @Input() content: string;

    /* PROPERTIES*/
    public _pageSizes: number[] = [5, 10, 15, 20, 25, 30, 50, 100];

    get pageTotal() {
        return Math.ceil(Number(this.rowsTotal) / Number(this.pageSize)) || 1;
    }

    private get _sieveFilters(): ISieveFilterObject[] {
        return [];
    }
    private get _sieveConf(): ISieveConf {
        const sieveConf: ISieveConf = {};
        sieveConf.page = this.page;
        sieveConf.pageSize = this.pageSize;
        sieveConf.filters = this._sieveFilters;
        return sieveConf;
    }

    constructor() { }

    //CHANGE PAGE or PAGE SIZE
    private _onPageChange() {
        this.changePageEvent.emit(this._sieveConf);
    }

    changePageSize() {
        this.page = 1;
        this._onPageChange();
    }

    pageNext() {
        if (this.page < this.pageTotal) {
            this.page++;
            this._onPageChange();
        }
    }

    pagePrev() {
        if (this.page > 1) {
            this.page--;
            this._onPageChange();
        }
    }

    pageFirst() {
        this.page = 1;
        this._onPageChange();
    }

    pageLast() {
        this.page = this.pageTotal;
        this._onPageChange();
    }

    //SEARCH
    private _onFilterSearch() {
        this.page = SieveString.DEAFULT_PAGE;
        this.searchBox.emit(JSON.stringify({ prop: this.property, val: this.content }));
    }
    
    confirmSearch() {
        this.closeSearchBox.emit(true);
        this._onFilterSearch();
    }

    // REFRESH
    refreshData() {
        console.log('sieve refresh');
        this.changePageEvent.emit(this._sieveConf);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/search-box/searchbox.component.ts